import React from "react";

interface ModalProps {
    open: boolean;
    onClose: () => void;
    children: React.ReactNode;
    maxWidth?: string;
}

export default function Modal({ open, onClose, children, maxWidth }: ModalProps) {
    if (!open) return null; // Prevent render when closed

    return (
        <div style={styles.overlay}>
            <div
                style={{...styles.modal, width: maxWidth || "50%"}}
                onClick={(e) => e.stopPropagation()} // Prevent close when clicking inside
            >
                <div>{children}</div>
            </div>
        </div>
    );
}

const styles: Record<string, React.CSSProperties> = {
    overlay: {
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        background: "rgba(0,0,0,0.6)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 999,
    },
    modal: {
        background: "#fff",
        padding: "1.5rem",
        borderRadius: "10px",
        width: "50%",
        maxWidth: "90%",
        minHeight: "50%"
    },
    closeButton: {
        marginTop: "1rem",
        padding: "0.5rem 1rem",
        cursor: "pointer",
    },
};
